module.exports = __webpack_public_path__ + "img/baohandaikuan.8fa4f405.png";